module.exports = __webpack_public_path__ + "static/media/1Asset-8Digital.3c2601ee.png";